import React from "react";
import classnames from "classnames";
import { EyeIcon, PencilIcon, TrashIcon } from "@aureskonnect/react-ui";
import { useTranslation } from "react-i18next/";
import { useSnapshot } from "valtio";
import { Tooltip } from "@mui/material";
import store, {
    setActions,
    setIsActionsClicked,
    setIsEdited,
    setSelectedApplicationKds,
} from "./store";

import TimePastSvgIcon from "@components/Common/SvgIcons/TimePastSvgIcon";
import ErrorToast from "@components/Common/ErrorTost";
import ConsultSvgIcon from "@components/Common/SvgIcons/ConsultSvgIcon";

export function CustomIcons({
    e,
    setSelectedRows,
    isAddApplication,
    setIsAddApplication,
    isApplicationArchived,
    setIsHistoryModalOpened,
    isHistoryModalOpened,
    setIsConfirmationModalArchived,
    setIsConfirmationModalActive,
    setIsConsult,
}: any) {
    const { t } = useTranslation();
    const { modify, isEdited, isActionsClicked } = useSnapshot(store);
    return (
        <React.Fragment>
            {e.selectedRow?.subRows !== undefined &&
            e.selectedRow["Application"] !== "" ? (
                <div className="d-flex justify-content-between mt-2">
                    {modify === false || isApplicationArchived ? (
                        <Tooltip title={t("To consult")}>
                            <div>
                                <ConsultSvgIcon
                                    onClick={() => {
                                        setIsConsult(true);
                                        if (isEdited === true) {
                                            setIsActionsClicked(
                                                !isActionsClicked
                                            );
                                            setActions(() => {
                                                setIsEdited(false);
                                                setSelectedRows([
                                                    e.selectedRow,
                                                ]);
                                                if (!isAddApplication) {
                                                    setIsAddApplication(
                                                        !isAddApplication
                                                    );
                                                }
                                            });
                                        } else {
                                            setSelectedRows([e.selectedRow]);
                                            if (!isAddApplication) {
                                                setIsAddApplication(
                                                    !isAddApplication
                                                );
                                            }
                                        }
                                    }}
                                    height={35}
                                    width={35}
                                    style={{
                                        cursor: "pointer",
                                        position: "relative",
                                        bottom: "5px",
                                    }}
                                    fill="black"
                                    className={`${classnames(
                                        "pointer__clz cmn_icn_FRedit"
                                    )}`}
                                />
                            </div>
                        </Tooltip>
                    ) : null}
                    {modify === true && !isApplicationArchived && (
                        <div>
                            <PencilIcon
                                onClick={() => {
                                    if (isEdited === true) {
                                        setIsActionsClicked(!isActionsClicked);
                                        setActions(() => {
                                            setIsEdited(false);
                                            setSelectedRows([e.selectedRow]);
                                            if (!isAddApplication) {
                                                setIsAddApplication(
                                                    !isAddApplication
                                                );
                                            }
                                        });
                                    } else {
                                        setSelectedRows([e.selectedRow]);
                                        if (!isAddApplication) {
                                            setIsAddApplication(
                                                !isAddApplication
                                            );
                                        }
                                    }
                                }}
                                height={25}
                                width={25}
                                style={{ cursor: "pointer" }}
                                className={`${classnames(
                                    "pointer__clz cmn_icn_edit",
                                    {
                                        "not-allowed-icon__clz": isApplicationArchived,
                                    }
                                )}`}
                            />
                        </div>
                    )}
                    {modify === true && (
                        <div>
                            {!isApplicationArchived ? (
                                <TrashIcon
                                    onClick={() => {
                                        if (isEdited === true) {
                                            setIsActionsClicked(
                                                !isActionsClicked
                                            );
                                            setActions(() => {
                                                setIsConsult(false);
                                                setIsAddApplication(false);
                                                setIsEdited(false);
                                                if (
                                                    e.selectedRow.subRows
                                                        .length > 0
                                                ) {
                                                    ErrorToast(
                                                        t(
                                                            "Please note that you cannot archive a application associated with an device."
                                                        )
                                                    );
                                                } else {
                                                    setIsConfirmationModalArchived(
                                                        true
                                                    );
                                                }

                                                setSelectedRows([
                                                    e.selectedRow,
                                                ]);
                                            });
                                        } else {
                                            setIsConsult(false);
                                            setIsAddApplication(false);
                                            if (
                                                e.selectedRow.subRows.length > 0
                                            ) {
                                                ErrorToast(
                                                    t(
                                                        "Please note that you cannot archive a application associated with an device."
                                                    )
                                                );
                                            } else {
                                                setIsConfirmationModalArchived(
                                                    true
                                                );
                                            }

                                            setSelectedRows([e.selectedRow]);
                                        }
                                    }}
                                    height={25}
                                    width={25}
                                    fill="red"
                                    style={{ cursor: "pointer" }}
                                    className={`${classnames(
                                        "pointer__clz ml-1 cmn_icn_FRarchived"
                                    )}`}
                                />
                            ) : (
                                <EyeIcon
                                    height={25}
                                    width={25}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        if (isEdited === true) {
                                            setIsActionsClicked(
                                                !isActionsClicked
                                            );
                                            setActions(() => {
                                                setIsEdited(false);
                                                setIsConsult(false);
                                                setIsConfirmationModalActive(
                                                    true
                                                );
                                                setSelectedRows([
                                                    e.selectedRow,
                                                ]);
                                            });
                                        } else {
                                            setIsConsult(false);
                                            setIsConfirmationModalActive(true);
                                            setSelectedRows([e.selectedRow]);
                                        }
                                    }}
                                    className={`${classnames(
                                        "pointer__clz ml-1 cmn_icn_unarchive",
                                        {}
                                    )}`}
                                />
                            )}
                        </div>
                    )}
                    <div>
                        <TimePastSvgIcon
                            onClick={() => {
                                if (isEdited === true) {
                                    setIsActionsClicked(!isActionsClicked);
                                    setActions(() => {
                                        setIsConsult(false);
                                        setIsEdited(false);
                                        setSelectedApplicationKds([
                                            {
                                                [e.selectedRow.shopId]:
                                                    e.selectedRow.appId,
                                            },
                                        ]);
                                        setIsHistoryModalOpened(
                                            !isHistoryModalOpened
                                        );
                                        setIsAddApplication(false);

                                        setSelectedRows([e.selectedRow]);
                                    });
                                } else {
                                    setIsConsult(false);
                                    setSelectedApplicationKds([
                                        {
                                            [e.selectedRow.shopId]:
                                                e.selectedRow.appId,
                                        },
                                    ]);
                                    setIsHistoryModalOpened(
                                        !isHistoryModalOpened
                                    );
                                    setIsAddApplication(false);
                                    setSelectedRows([e.selectedRow]);
                                }
                            }}
                            className={`${classnames(
                                "pointer__clz cmn_icn_history",
                                "ml-2"
                            )}`}
                        />
                    </div>
                </div>
            ) : null}
        </React.Fragment>
    );
}
